// Environment variables'dan API key'leri al
// .env.local dosyasında REACT_APP_ prefix'i ile tanımlanmalı
// NOT: .env.local kullanıyoruz çünkü:
// - .env: Tüm ortamlar için (git'e commit edilebilir, genel config)
// - .env.local: Local development için (git'te ignore edilir, kişisel config)
// - .env.production: Production build için (AWS Amplify'da environment variables olarak ayarlanır)

export const mapTilerKey = process.env.REACT_APP_MAPTILER_KEY || "eb6L6NoZoZhWFyDlpOhz";
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

// AWS Cognito Configuration
export const cognitoConfig = {
  region: process.env.REACT_APP_AWS_REGION || "us-east-1",
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
  userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
  identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || "",
};

console.log("🔑 MapTiler API Key yüklendi:", mapTilerKey ? "✅ Tanımlı" : "❌ Tanımlı değil");
console.log("🔑 Google Maps API Key yüklendi:", googleMapsApiKey ? "✅ Tanımlı" : "❌ Tanımlı değil - Lütfen .env.local dosyasına REACT_APP_GOOGLE_MAPS_API_KEY ekleyin");
console.log("🔑 AWS Cognito Config:", {
  region: cognitoConfig.region,
  userPoolId: cognitoConfig.userPoolId ? "✅ " + cognitoConfig.userPoolId : "❌ Tanımlı değil",
  clientId: cognitoConfig.userPoolWebClientId ? "✅ " + cognitoConfig.userPoolWebClientId.substring(0, 10) + "..." : "❌ Tanımlı değil",
  identityPoolId: cognitoConfig.identityPoolId ? "✅ " + cognitoConfig.identityPoolId.substring(0, 20) + "..." : "❌ Tanımlı değil - Admin API için gerekli!"
});